import TransactionsHistory from '../../common/TransactionsHistory';

const DepositTransactions = (props) => (
  <TransactionsHistory type="deposit" {...props} />
);

export default DepositTransactions;
